import "./App.css";
import { PrimeReactProvider } from "primereact/api";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import GlobalRouters from "./routes/GlobalRouters";
import { ability } from "./ability/ability";
import { AbilityContext } from "./ability/can";

function App() {
  const isLoggedIn = localStorage.getItem("loggedIn") === "true";

  const router = createBrowserRouter([
    {
      path: "/*",
      element: <GlobalRouters isLoggedIn={isLoggedIn} />,
    },
  ]);

  return (
    <PrimeReactProvider>
      <AbilityContext.Provider value={ability}>
        <RouterProvider router={router} />
      </AbilityContext.Provider>
    </PrimeReactProvider>
  );
}

export default App;
